import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "assets/logo.svg";
import logoLight from "assets/logo.svg";
import { headerLinks } from "utils/helper/links";
import { AnimateType, classNames, goToTop } from "utils/helper/helper";
import Reveal from "components/toolkit/reveal.component";
import Sidebar from "./sidebar.component";
import DarkModeToggle from "components/toolkit/theme-toggle.component";
import HeaderProfile from "./header-profile.component";
import HeaderUserDropdown from "./user-dropdown.component";
import ContactModal, { ContactContent } from "components/contact";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "store/user/user.selector";

const Header = ({ isDefault = true }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const hide = searchParams.get("hide") === "1";

  const user = useSelector(selectCurrentUser);
  const [scrolled, setScrolled] = useState<boolean>(false),
    [showSidebar, setShowSidebar] = useState<boolean>(false),
    [isContactOpen, setIsContactOpen] = useState<boolean>(false),
    //
    toggleShowSidebar = (value?: boolean) => {
      if (value != null) {
        setShowSidebar(value);
        return;
      }
      setShowSidebar((state) => !state);
    },
    handleContactOpen = (value?: boolean) => setIsContactOpen(true);
  useEffect(() => {
    // Define a function to check the scroll position and update the state.
    const handleScroll = () => {
      if (window.scrollY >= 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Attach the scroll event listener to the window when the component mounts.
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts to prevent memory leaks.
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <header
        className={classNames(
          "js-page-header fixed top-0 z-20 w-full",
          scrolled
            ? "bg-white/20 dark:bg-black/20 backdrop-blur transition-colors"
            : ""
        )}
      >
        <div className="flex items-center justify-between lg:justify-normal px-6 py-6 xl:px-24 ">
          <NavLink className="shrink-0" to="/">
            <div className="dark:hidden">
              <img
                alt="orange's Exchange"
                loading="lazy"
                width={130}
                height={28}
                decoding="async"
                data-nimg={1}
                className="max-h-7 h-auto "
                style={{ color: "transparent" }}
                src={logo}
              />
            </div>
            <div className="hidden dark:block">
              <img
                alt="orange's Exchange"
                loading="lazy"
                width={130}
                height={28}
                decoding="async"
                data-nimg={1}
                style={{ color: "transparent" }}
                src={logoLight}
              />
            </div>
          </NavLink>
          {isDefault && (
            <>
              <div className="js-mobile-menu dark:bg-marshland-800 invisible fixed inset-0 z-10 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent">
                <nav className="navbar w-full">
                  <ul className="flex flex-col lg:flex-row">
                    {headerLinks.map((item, i) => (
                      <li className="group" key={i}>
                        {item.uri === "/worker-signup" &&
                        user &&
                        user.businessName ? (
                          <div className="px-5"></div>
                        ) : item.uri !== "/contact-us" ? (
                          <NavLink
                            to={item.uri}
                            className={({ isActive }) =>
                              classNames(
                                "font-display hover:text-orange-600 focus:text-orange-600",
                                "dark:hover:text-orange-600 dark:focus:text-orange-600 flex items-center",
                                "justify-between py-3.5 text-base dark:text-white lg:px-5",
                                isActive
                                  ? "text-orange-600 dark:text-orange-600"
                                  : "text-marshland-700"
                              )
                            }
                          >
                            <span className="">{item.label}</span>
                          </NavLink>
                        ) : (
                          // <a
                          //   href="mailto:example@gmail.com?subject=Hello&body=How%20are%20you%3F"
                          //   className={classNames(
                          //     "font-display hover:text-orange-600 focus:text-orange-600",
                          //     "dark:hover:text-orange-600 dark:focus:text-orange-600 flex items-center",
                          //     "justify-between py-3.5 text-base dark:text-white lg:px-5",
                          //     "text-marshland-700"
                          //   )}
                          // >
                          //   Send Email
                          // </a>
                          <ContactModal
                            openModel={() => setIsContactOpen(true)}
                          />
                        )}
                      </li>
                    ))}

                    <li className="py-3.5">
                      <HeaderProfile />
                    </li>
                  </ul>
                </nav>
                <div className="ml-8 hidden items-center lg:flex xl:ml-12">
                  <DarkModeToggle />
                </div>
              </div>
              <div className="flex items-center lg:hidden">
                {!hide && <HeaderUserDropdown />}
                <DarkModeToggle />
                {!hide && (
                  <button
                    className="js-mobile-toggle border-marshland-100 hover:bg-orange-600 dark:hover:bg-orange-600 focus:bg-orange-600 group ml-2 flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]"
                    aria-label="open mobile menu"
                    onClick={() => toggleShowSidebar()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width={24}
                      height={24}
                      className="fill-marshland-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M18 18v2H6v-2h12zm3-7v2H3v-2h18zm-3-7v2H6V4h12z" />
                    </svg>
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </header>
      {scrolled && (
        <Reveal
          type={AnimateType.FadeInUp}
          className="fixed z-[9999999999]  right-6 bottom-[124px] md:bottom-[180px] gizmo:md:bottom-[143px] lg:bottom-[80px]"
        >
          <button
            onClick={goToTop}
            className={classNames(
              "cursor-pointer bg-orange-600 group ml-2 flex h-10 w-10 items-center justify-center",
              " rounded-full border border-marshland-100 transition-colors hover:border-transparent",
              "hover:bg-orange-600 focus:border-transparent focus:bg-orange-600",
              "dark:border-transparent dark:bg-white/[.15] dark:hover:bg-orange-600 text-white"
            )}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="icon-sm m-1"
              height="1em"
              width="1em"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
              />
            </svg>
          </button>
        </Reveal>
      )}
      {showSidebar && (
        <Sidebar
          toggleShowSidebar={toggleShowSidebar}
          setIsContactOpen={handleContactOpen}
        />
      )}
      {isContactOpen && (
        <ContactContent
          {...{ isContactOpen, closeModel: () => setIsContactOpen(false) }}
        />
      )}
    </>
  );
};

export default Header;
